import { ObjectWithStringValuesI } from '../types/common';

export const COLUMN_CONSTRAINTS: ObjectWithStringValuesI = {
  PRIMARY_KEY: 'PRIMARY_KEY',
  NOT_NULL: 'NOT_NULL',
  UNIQUE: 'UNIQUE',
  AUTO_INCREMENT: 'AUTO_INCREMENT',
  FOREIGN_KEY: 'FOREIGN_KEY',
};

export const COLUMN_CONSTRAINTS_COLORS: ObjectWithStringValuesI = {
  PRIMARY_KEY: 'green',
  NOT_NULL: 'red',
  UNIQUE: 'cyan',
  AUTO_INCREMENT: 'yellow',
  FOREIGN_KEY: 'purple',
};

export const COLUMN_DATATYPES = {
  TINYINT: 'TINYINT',
  SMALLINT: 'SMALLINT',
  MEDIUMINT: 'MEDIUMINT',
  INT: 'INT',
  BIGINT: 'BIGINT',
  FLOAT: 'FLOAT',
  DOUBLE: 'DOUBLE',
  DECIMAL: 'DECIMAL',
  NUMERIC: 'NUMERIC',
  BINARY_FLOAT: 'BINARY_FLOAT',
  BINARY_DOUBLE: 'BINARY_DOUBLE',
  DOUBLE_PRECISION: 'DOUBLE_PRECISION',
  REAL: 'REAL',
  CHAR: 'CHAR',
  NCHAR: 'NCHAR',
  VARCHAR: 'VARCHAR',
  NVARCHAR: 'NVARCHAR',
  VARCHAR2: 'VARCHAR2',
  NVARCHAR2: 'NVARCHAR2',
  TINYTEXT: 'TINYTEXT',
  TEXT: 'TEXT',
  NTEXT: 'NTEXT',
  MEDIUMTEXT: 'MEDIUMTEXT',
  LONG: 'LONG',
  LONGTEXT: 'LONGTEXT',
  ENUM: 'ENUM',
  SET: 'SET',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  DATETIME2: 'DATETIME2',
  SMALLDATETIME: 'SMALLDATETIME',
  DATETIMEOFFSET: 'DATETIMEOFFSET',
  TIMESTAMP: 'TIMESTAMP',
  TIME: 'TIME',
  YEAR: 'YEAR',
  BINARY: 'BINARY',
  VARBINARY: 'VARBINARY',
  TINYBLOB: 'TINYBLOB',
  MEDIUMBLOB: 'MEDIUMBLOB',
  BLOB: 'BLOB',
  LONGBLOB: 'LONGBLOB',
  CLOB: 'CLOB',
  NCLOB: 'NCLOB',
  BFILE: 'BFILE',
  RAW: 'RAW',
  LONGRAW: 'LONGRAW',
  BOOL: 'BOOL',
  BOOLEAN: 'BOOLEAN',
  BIT: 'BIT',
};
